import React, { FC } from "react";
import SVG from "./SVG";

type SocialIconComponent = {
  url: string;
  target: string;
  icon: string;
  lightIcon: string;
  alt: string;
  twClasses: string;
  text: string;
};

const SocialIcon: FC<SocialIconComponent> = ({
  url,
  target,
  icon,
  alt,
  twClasses,
  text,
  lightIcon,
}) => {
  return (
    <div>
      <button className="p-0 transition-transform hover:scale-[1.05]">
        <a
          href={url}
          target={target}
          className="flex items-center gap-x-1.5 px-3 py-2 rounded-xl border border-sleap-gray-400"
        >
          <SVG
            alt={alt}
            twClasses={`${twClasses} dark:hidden`}
            src={lightIcon}
          />{" "}
          <SVG
            alt={alt}
            twClasses={`${twClasses} dark:block hidden`}
            src={icon}
          />{" "}
          <span className="mb-0 text-base dark:text-sleap-gray-100 text-sleap-gray-950  font-inter">
            {text}
          </span>
        </a>
      </button>
    </div>
  );
};

export default SocialIcon;
